import { Preferences } from '@capacitor/preferences';

export default class Storage {
	constructor(_options) {
	}

	async load(key) {
		let data = null;

		let dataRaw = null;
		try {
			if (localStorage && localStorage.getItem) {
				dataRaw = localStorage.getItem(key);
			}
		} catch (e) {
			console.log('Error in load: ' + e);
		}
		if (dataRaw === null) {
			try {
				const { value } = await Preferences.get({key,});
				dataRaw = value;
			} catch (e) {
				console.log('Error in load: ' + e);
			}
		}

		if (dataRaw !== null && dataRaw != '{}') {
			try {
				data = JSON.parse(dataRaw);
			} catch (e) {
				data = null; //error in the above string(in this case,yes)!
			}

		}

		return data;
	}

	async save(key, data) {
		const jsonData = JSON.stringify(data);

		try {
			localStorage[key] = jsonData;
		} catch (e) {
			console.warn('save: ' + e);
		}

		//save to local file
		await Preferences.set({
			key,
			value: jsonData,
		});
	}
}
